import { Directive, ElementRef, Input, OnInit, ViewContainerRef } from '@angular/core';
import { MbTooltipTrigger } from '@am/moebius';
import { Overlay } from '@angular/cdk/overlay';
import { Platform } from '@angular/cdk/platform';
import { EllipsisPipe } from './ellipsis.pipe';

@Directive({
    selector: '[custom-tooltip]',
    standalone: true,
})
export class CustomTooltipDirective extends MbTooltipTrigger implements OnInit {
  @Input()
  wordLimit: number = undefined;

  private ellipsisPipe: EllipsisPipe;

  constructor(
    overlay: Overlay,
    vcr: ViewContainerRef,
    elementRef: ElementRef<HTMLElement>,
    platform: Platform,
  ) {
    super(overlay, vcr, elementRef, platform);
    this.ellipsisPipe = new EllipsisPipe();
  }

  ngOnInit() {
    if (
      this.wordLimit &&
      this.ellipsisPipe.transform(this.mbTooltipText(), this.wordLimit).includes('...')
    ) {
      super.ngOnInit();
    }
  }
}
